/* unplugin-vue-components disabled */import { render } from "./DeptListItem.vue?vue&type=template&id=36e64b78&scoped=true&ts=true"
import script from "./DeptListItem.vue?vue&type=script&lang=ts"
export * from "./DeptListItem.vue?vue&type=script&lang=ts"

import "./DeptListItem.vue?vue&type=style&index=0&id=36e64b78&lang=less&scoped=true"

import exportComponent from "D:\\项目\\blueSkyReportForm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36e64b78"]])

export default __exports__